<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
  <h5 class="mb-0">
    Torneos
  </h5>
  <!-- <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
    <li class="breadcrumb-item position-relative">
      <a routerLink="/" class="d-inline-block position-relative">
        <i class="ri-home-8-line"></i>
        Dashboard
      </a>
    </li>
    <li class="breadcrumb-item position-relative">
      Apps
    </li>
    <li class="breadcrumb-item position-relative">
      To Do List
    </li>
  </ol> -->
</div>

<!-- @if(tournamentsState$ | async; as state) {
  <!- @if(state.status === ContentStatus.INITIATED) {
    Init
  } ->
  @if(state.status === ContentStatus.LOADING) {
    <div class="big-loading">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (state.status === ContentStatus.ERROR) {
    Error
  } @else if (state.status === ContentStatus.OK) {
    <tournaments-ui
      [tournamentsState]="state.value"
    ></tournaments-ui>
  }
} -->

@if (!hasAttemptedLoad()) {
  <div>Init</div>
} @else {
  @if (isLoading()) {
    <div class="big-loading">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    @if (error()) {
      <div>Error</div>
    } @else {
      <tournaments-ui
        [tournaments]="tournaments()"
      ></tournaments-ui>

      <!-- <div>data2: {{ data2() | json }}</div> -->
    }
  }
}
